<template>
    <div class="flex justify-between items-center w-full">
        <div class="mr-2">
            {{ params.displayName }}
        </div>
        <div
            v-if="params.enableSorting"
            class="px-2 transition-all rounded hover:bg-info-300 cursor-pointer"
            :class="noSort ? 'bg-gray-100' : 'bg-info-200'"
            @click="onSortRequested($event)">
            <div class="flex items-center gap-2">
                <hi-x-circle-icon
                    v-if="!noSort"
                    class="w-4 h-4 text-error-500 cursor-pointer"
                    @click="clearSortRequested($event)" />
                <hi-chevron-double-down-icon
                    class="h-5 w-5 font-bold transition-all"
                    :class="{
                        'text-gray-800': noSort,
                        'rotate-180': descSort
                    }" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: {
    type: Object,
    required: true
  }
})

const { params } = toRefs(props)

const menuButton = ref(null)

const ascSort = ref(null as string | null)
const descSort = ref(null as string | null)
const noSort = ref(null as string | null)

onMounted(() => {
  if (!params.value) {
    return
  }
  params.value.column?.addEventListener('sortChanged', onSortChanged)
  onSortChanged()
})

const onMenuClicked = () => {
  params.value.showColumnMenu(menuButton.value)
}

const onSortChanged = () => {
  if (!params.value) {
    return
  }

  ascSort.value = null
  descSort.value = null
  noSort.value = null

  if (params.value.column.isSortAscending()) {
    ascSort.value = 'active'
  } else if (params.value.column.isSortDescending()) {
    descSort.value = 'active'
  } else {
    noSort.value = 'active'
  }
}

const onSortRequested = (event: any) => {
  if (noSort.value || descSort.value) {
    params.value.setSort('asc', event.shiftKey)
    return
  }

  if (ascSort.value) {
    params.value.setSort('desc', event.shiftKey)
  }
}

const clearSortRequested = (event: any) => {
  event.preventDefault()
  event.stopPropagation()
  params.value.setSort('', event.shiftKey)
}
</script>
